import {Component, OnInit} from '@angular/core';
import {DataObjComponent, DataObjComponentHelper} from '../../rest-service';
import {Extension, ExtensionService} from '../../extension.service';
import {Router} from '@angular/router';
import {NotificationService} from '../../notification.service';
import {UserService} from '../../user.service';

@Component({
  selector: 'app-extension',
  templateUrl: './extension.component.html',
  styleUrls: ['./extension.component.css']
})
export class ExtensionComponent implements OnInit, DataObjComponent<Extension> {

  readonly namePlural = 'Ramais';

  readonly editPath = '/extensions/';

  readonly newPath = '/extensions_new';

  helper: DataObjComponentHelper<Extension>;

  constructor(private service: ExtensionService, private router: Router, private ns: NotificationService,
              private us: UserService) {
    this.helper = new DataObjComponentHelper<Extension>(this.service, ns, this.us, this.router, this.editPath);
  }

  ngOnInit() {
    this.helper.onInit();
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/extension/extension/extension.component.ts